import { create } from 'zustand';

type DeleteTopicGroupModalStore = {
  isOpen: boolean;
  topicGroupId: string;
  topicGroupName: string;
  openModal: (params: { topicGroupId: string; topicGroupName: string }) => void;
  closeModal: () => void;
};

/**
 * Simple Zustand store for the delete topic group modal actions.
 */
export const useDeleteTopicGroupModal = create<DeleteTopicGroupModalStore>((set) => ({
  isOpen: false,
  topicGroupId: '',
  topicGroupName: '',
  openModal: ({ topicGroupId, topicGroupName }) => set({ isOpen: true, topicGroupId, topicGroupName }),
  closeModal: () => set({ isOpen: false, topicGroupId: '', topicGroupName: '' })
}));
